module.exports = __webpack_public_path__ + "static/media/close-red.fcbcf228.svg";